<template>
  <div>
    <header class="header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12"> <a href=""> <img class="img-responsive" src="@/assets/images/iconlogo.png" alt="logo"> </a>
            <button type="button" class="btn btn-light radius-20 ml-3"><img alt="" class="plus-img" src="@/assets/images/play.png"> Projekt</button>
            <div class="title-of-header d-none d-sm-block">WH97 new building part B, Cologne - Brand GmbH</div>
            <div class="dropdown float-right mt-1"> <span class="font-10">Stuart Heller</span> <a class="dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#">
                  <img class="img-responsive" src="@/assets/images/Shape.png" alt="user"> Profil bearbeiten
                </a>
                <a class="dropdown-item" href="#"><img class="img-responsive" src="@/assets/images/Shape1.png" alt="shapw"> Sprache (Deutsch)</a>
                <a class="dropdown-item" href="#">
<!--                <img class="img-responsive" src="@/assets/images/Shape2.png" alt="shapw"> Kundenadministration</a> <a class="dropdown-item" href="#">-->
                <img class="img-responsive" src="@/assets/images/Shape3.png" alt="shapw">
                 Abmelden
                </a>
              </div>
            </div>
            <div class="profile-pic float-right"> <img class="img-responsive mr-3" src="@/assets/images/setting.png" alt="user"> <a href="account-settings.html" class="mr-3"> <img src="@/assets/images/user.png" width="32" height="32" alt="profile" class="rounded-circle"> </a> </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>



// WEBPACK FOOTER //
// src/components/appSetting/components/Header.vue